import { useEffect } from "react";
import { Badge, Group, Loader, Tooltip } from "@mantine/core";
import { useJobsActivityStore } from "./jobsActivityStore";

export default function ActivityIndicator() {
  const { totalActive, startPolling, stopPolling, getTooltipText } =
    useJobsActivityStore();

  useEffect(() => {
    startPolling();
    return () => stopPolling();
  }, []);

  if (totalActive === 0) return null;

  return (
    <Tooltip label={getTooltipText()}>
      <Group gap={6} style={{ cursor: "default" }}>
        <Loader size="xs" type="dots" />
        <Badge size="sm" variant="light" color="blue" circle>
          {totalActive}
        </Badge>
      </Group>
    </Tooltip>
  );
}
